var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { showFlash } from '../flash_show';
import i18n from '../../i18n';
// We use the same mechanism for detecting adblockers in the widget. See https://github.com/steady-media/steady-widget-2.0/blob/main/src/adblock_detector.ts.
function detectAdBlocker() {
    return __awaiter(this, void 0, void 0, function* () {
        return new Promise(resolve => {
            const testURL = 'https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js';
            const xhr = new XMLHttpRequest();
            xhr.open('get', testURL, true);
            xhr.onload = () => {
                if (xhr.readyState === 4) {
                    if (xhr.status === 200) {
                        // Some ad blockers may return a fake response with status 200 and body size 1 (it used to be the case for uBlock origin).
                        // uBlock origin intercepts the request (that's possible via the Chrome web request API) and redirects it to a `data:something` url,
                        // so checking that `responseURL` equals `testURL' ensures that the request wasn't intercepted and modified.
                        if (xhr.responseText.length > 1 && xhr.responseURL === testURL) {
                            resolve(false);
                        }
                        else {
                            resolve(true);
                        }
                    }
                    else {
                        resolve(true);
                    }
                }
            };
            xhr.onerror = () => {
                resolve(true);
            };
            xhr.send();
        });
    });
}
window.up.compiler('.js-backend_publication_traffic_enabled', function (element) {
    return __awaiter(this, void 0, void 0, function* () {
        const adBlockerEnabled = yield detectAdBlocker();
        const host = element === null || element === void 0 ? void 0 : element.dataset.host;
        if (adBlockerEnabled) {
            showFlash('info', i18n.$gettext('If you cannot see your traffic data via Plausible on this page, this might be due to an ad blocker you are using. Please change the settings on your ad blocker (e.g. by adding an exception for %{host}) or use another browser.', { host }));
        }
    });
});
